<template>
  <div class="shelters-overview">
    <fn-cms-section-loader
      v-if="page?.content?.content_slots?.a?.sections"
      :sections="page.content.content_slots.a.sections"
      sub-sections
    />
    <fn-section
      ref="shelters-section"
      :constrained="sectionConstraint"
      padding-top="s"
      padding-bottom="s"
    >
      <fn-shelters-list
        :id="'shelters-list'"
        :title="page?.content?.content_slots?.shelters_list_title"
        :shelters="shelters"
        :total-page-count="totalPageCount"
        :current-page="currentPage - 1"
        :is-loading="isLoading"
        @page-change="handleGoToPage"
      />
    </fn-section>
    <fn-cms-section-loader
      v-if="page?.content?.content_slots?.b?.sections"
      :sections="page.content.content_slots.b.sections"
      sub-sections
    />
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  page: any;
}>();

const { getSheltersList } = useMainStore();
const route = useRoute();
const sheltersSection = useTemplateRef<ComponentPublicInstance>('shelters-section');

const sectionConstraint =
  props.page?.content?.content_slots?.a?.sections?.[0]?.constrained ||
  props.page?.content?.content_slots?.b?.sections?.[0]?.constrained ||
  'm';

const pageSize = 2;
const currentPage = ref(Number(route.query.page) || 1);

const { data: sheltersData, status } = await useAsyncData<any>(
  () =>
    getSheltersList({
      currentPage: currentPage.value - 1,
      pageSize,
    }),
  {
    watch: [currentPage],
  },
);

const isLoading = computed(() => status.value === 'pending');
const shelters = computed(() => sheltersData.value.shelters || []);
const totalPageCount = computed(() => sheltersData.value.totalPageCount || 1);

async function handleGoToPage(page: number) {
  currentPage.value = page;

  const url = new URL(location.href);

  if (page > 1) {
    url.searchParams.set('page', String(page));
  } else {
    url.searchParams.delete('page');
  }

  history.pushState('', '', url.toString());

  sheltersSection.value?.$el.scrollIntoView({
    behavior: 'smooth',
  });
}
</script>

<style scoped lang="scss">
.shelters-overview {
  position: relative;
}
</style>
